import moment from 'moment';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { bannerStyles } from '../../styles/banner-styles';
import { sharedStyles } from '../../styles/shared-styles';
import '../props/bin-name';
import '../../common/bn-modal-button';
import './bin-probation-explanation-modal';

class BinProbationBanner extends LitEntity {
  static get properties() {
    return {
      probation: { type: Object, attribute: false },
    };
  }

  static get styles() {
    return [bannerStyles, sharedStyles, css`
      h3 {
        margin: 0.125rem 0;
        font-weight: bold;
        color: var(--blue-60);
      }
      .banner {
        margin: var(--root-margin);
        padding: .75em;
        display: flex;
        align-items: center;
      }
      .container {
        display: flex;
        align-items: center;
        color: var(--blue-60);
        flex-grow: 1;
      }
      .description {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
      }
      bn-icon {
        font-size: 3.25rem;
        padding: 0 .5em 0 .25em;
        margin: 0;
        align-self: flex-start;
      }
      bn-modal-button {
        margin: .5rem 0;
        font-size: .95rem;
      }
      @media(max-width: 800px) {
        .container {
          flex-wrap: wrap;
        }
      }
    `];
  }

  render() {
    const probationsHref = this.entity && (this.entity.getSubEntityByRel('https://api.binsentry.com/rel/probations') || {}).href;
    if (!probationsHref) {
      return html``;
    }

    return html`
      ${this._renderBanner()}
      <lit-entity .href="${probationsHref}" @update="${this._onProbationsUpdate}"></lit-entity>
    `;
  }

  _renderBanner() {
    if (this.loading || !this.probation) {
      return html``;
    }

    const { endDate, state } = this.probation.properties;
    if (state.includes('complete-')) {
      return html``;
    }

    return html`
      <div class="banner banner--info">
        <bn-icon name="fas fa-calendar-day"></bn-icon>
        <div class="container">
          <div class="description">
            <h3>This bin is in probation until <span title="${endDate}">${moment(endDate).format('MMM Do')}</span></h3>
            All data reported will be manually reviewed for accuracy at that time.
          </div>
          <bn-modal-button button-class="button--outlined">
            <bin-probation-explanation-modal slot="modal"></bin-probation-explanation-modal>
            <span slot="text">What is Probation?</span>
          </bn-modal-button>
        </div>
      </div>
    `;
  }

  _onProbationsUpdate(e) {
    const { entity } = e.detail;

    const probations = (entity && entity.getSubEntitiesByRel('https://api.binsentry.com/rel/probation')) || [];
    const waitingProbations = probations.filter((probation) => probation.properties.state.includes('waiting-'));
    this.probation = waitingProbations.length > 0 ? waitingProbations[0] : undefined;
    this.requestUpdate();
  }
}

window.customElements.define('bin-probation-banner', BinProbationBanner);
